import React, { useCallback, useEffect, useState } from "react";

// 3rd Party Library
import PropTypes from "prop-types";
import { useDetectClickOutside } from "react-detect-click-outside";

// Components
import BaseCustomSelect from '../Dropdown/CustomSelect.jsx';

const CustomSelect = (props) => {
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const ref = useDetectClickOutside({
    onTriggered: () => setIsMenuOpen(false),
  });

  useEffect(() => {
    setFilteredOptions(props?.options?.length ? props?.options : []);
  }, [props.options]);

  const handleChange = useCallback(
    (selectedOption) => {
      if (props?.isRadioOption) {
        props.onChange?.(selectedOption ? [selectedOption] : []);
      } else {
        props.onChange?.(selectedOption);
      }
    },
    [props?.isRadioOption, props?.onChange]
  );

  const normalizeValue = (val) => {
    if (!val) {
      return [];
    }
    // If the value is already an array of objects with { value, label }
    if (Array.isArray(val) && val.every((item) => item.value && item.label)) {
      return val;
    }
    // If the value is a single string like 'Option 1'
    if (typeof val === "string") {
      const foundOption = options.find(
        (option) => option.label === val || option.value === val
      );
      return foundOption ? [foundOption] : [];
    }
    // If the value is a single object { value: 'option1', label: 'Option 1' }
    if (val.value && val.label) {
      return [val];
    }
    return [];
  };
  return (
    <div
      ref={ref}
      style={props?.customStyle ? props.customStyle : {}}
      className={props?.customClassName}
    >
      <BaseCustomSelect
        searchable={true}
        options={props?.options}
        onChange={handleChange}
        isDisabled={props?.disabled}
        maxSelection={props.maxSelection ?? Infinity}
        defaultSelected={normalizeValue(props?.value)}
        placeholder={props?.placeholder}
        PreDifplaceholder={props?.PreDifplaceholder}
        multiSelect={props?.isMulti}
        withSelectAll={props?.withSelectAll}
        selectContainerClassName={props?.className}
        selectvalueClassName={props?.valueClassName}
        optionStyle={props?.optionStyle}
      />
    </div>
  );
};

export default React.memo(CustomSelect);
CustomSelect.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any,
      label: PropTypes.string,
    })
  ),
  onChange: PropTypes.func,
  optionStyle: PropTypes.func,
  isRadioOption: PropTypes.bool,
  isMulti: PropTypes.bool,
  disabled: PropTypes.bool,
  maxSelection: PropTypes.number,
  value: PropTypes.any,
  placeholder: PropTypes.string,
  PreDifplaceholder: PropTypes.string,
  withSelectAll: PropTypes.bool,
  className: PropTypes.string,
  valueClassName: PropTypes.string,
  customClassName: PropTypes.string,
  customStyle: PropTypes.string,
};



